var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon-info"),React.createElement("path",{"d":"M14.09,4.17H9.91V0h4.18Zm0,16.7V7.3H5.74v3.13H9.91V20.87H4.7V24H19.3V20.87Z","fill":"currentColor","key":1})]);
}

Info.defaultProps = {"id":"Ebene_1","data-name":"Ebene 1","viewBox":"0 0 24 24"};

module.exports = Info;

Info.default = Info;
